// helper function to maintain consistent action structure

const makeAction = (type = '', payload) => ({ type, payload })

export default makeAction



// WEBPACK FOOTER //
// ./src/store/helpers/makeAction.js